import { render, staticRenderFns } from "./formCustomer.vue?vue&type=template&id=666763a0"
import script from "./formCustomer.vue?vue&type=script&lang=js"
export * from "./formCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports